import {Fragment, h} from 'preact';
import Button from '../form/Button';
import Dialog from '../media/Dialog';
import {useCallback, useState} from 'preact/hooks';
import CreateJobForm from './CreateJobForm';
import {IconType} from '../media/Icon';

interface Props {
  onSuccess?(): any;
}

export default function CreateJobButton({onSuccess}: Props) {
  const [showDialog, toggleDialog] = useState(false);

  const dialog = {
    show: toggleDialog.bind(null, true),
    hide: toggleDialog.bind(null, false)
  };

  const click = useCallback((event: MouseEvent) => {
    event.stopPropagation();
    dialog.show();
  }, [dialog]);

  return (
    <Fragment>
      <Button
        small={true}
        primary={true}
        onClick={click}
        onlyIcon={IconType.CREATE_ITEM}
        tooltip="Create Job"
      />
      <Dialog show={showDialog} onRequestClose={dialog.hide}>
        {showDialog && (
          <CreateJobForm
            onCancel={dialog.hide}
            onSuccess={() => {
              dialog.hide();
              if (onSuccess) onSuccess();
            }}
          />
        )}
      </Dialog>
    </Fragment>
  )
}